module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_9-a3b03cc9b39e9eda4081416750f7b69f.svg";